/**
 * Minion kind catalogue (docs/12 M2): 11 enemy types. All light enemies die
 * in 1-2 hits — variety comes from FORMATION and BEHAVIOR, not from HP.
 * Behaviors live in minions.ts; tuning lives here.
 */
export type MinionKind =
  | 'drone' | 'fly' | 'elite' | 'bunker'
  | 'turret' | 'dome' | 'dasher' | 'weaver' | 'splitter' | 'mite' | 'sniper';

export interface MinionStats {
  hp: number;
  radius: number;
  texKey: string;
  frames: number;
  /** Dies on player contact (kamikaze) */
  kamikaze: boolean;
}

export const STATS: Record<MinionKind, MinionStats> = {
  drone: { hp: 30, radius: 18, texKey: 'boss/sentinel/drone', frames: 1, kamikaze: false },
  fly: { hp: 16, radius: 16, texKey: 'boss/hive/fly', frames: 2, kamikaze: true },
  elite: { hp: 70, radius: 26, texKey: 'boss/hive/fly-elite', frames: 1, kamikaze: false },
  // Statics — the "blow these up first" tier (docs/12 M8/M9/M3)
  bunker: { hp: 150, radius: 28, texKey: 'minion/bunker', frames: 2, kamikaze: false },
  turret: { hp: 55, radius: 22, texKey: 'minion/turret', frames: 2, kamikaze: false },
  dome: { hp: 150, radius: 34, texKey: 'minion/dome', frames: 2, kamikaze: false },
  // Light swarm — 1-2 hits, formation flavor (docs/12 M2)
  dasher: { hp: 24, radius: 16, texKey: 'minion/dasher', frames: 1, kamikaze: false },
  weaver: { hp: 24, radius: 17, texKey: 'minion/weaver', frames: 2, kamikaze: false },
  splitter: { hp: 40, radius: 21, texKey: 'minion/splitter', frames: 1, kamikaze: false },
  mite: { hp: 8, radius: 11, texKey: 'minion/mite', frames: 1, kamikaze: true },
  sniper: { hp: 30, radius: 19, texKey: 'minion/sniper', frames: 2, kamikaze: false },
};

export const DRONE = { orbitDist: 150, orbitSpeed: 1.1, fireInterval: 1.6, bulletSpeed: 260 };
export const FLY = { accel: 700, maxSpeed: 300 };
export const ELITE = { speed: 85, fireInterval: 2.4, ringCount: 6, bulletSpeed: 180 };
/** Bunker hits harder now (docs/12 M8) */
export const BUNKER = { fireInterval: 2.4, burst: 4, spread: 0.22, bulletSpeed: 250 };
/** Short leash, vicious rate — get out of its yard or melt (M9) */
export const TURRET = { range: 520, fireInterval: 0.55, bulletSpeed: 320, bulletLife: 1.0 };
/** One HUGE telegraphed shell (M3) */
export const DOME = {
  chargeTime: 4.5, blinkTime: 1.4, bulletSpeed: 130, bulletRadius: 24, bulletLife: 8, damage: 3,
};
export const DASHER = { speed: 250, zigInterval: 0.7, zigAngle: 1.0, bulletSpeed: 240 };
export const WEAVER = { speed: 130, waveAmp: 240, waveFreq: 1.6, mineInterval: 1.4 };
export const SPLITTER = { speed: 110, children: 2 };
export const MITE = { accel: 900, maxSpeed: 340 };
export const SNIPER = {
  comfort: 520, retreat: 90, strafe: 70, fireInterval: 3.6, aimTime: 0.8, bulletSpeed: 430,
};
